import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../styles/Navbar.css';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <nav className="navbar navbar-light px-3 px-md-5 d-flex justify-content-between align-items-center">
        <button className="btn d-lg-none" onClick={toggleMenu}>
          <i className="bi bi-list fs-2 text-primary"></i>
        </button>

        <ul className="navbar-nav ms-auto d-none d-lg-flex flex-row gap-3">
          <li><NavLink to="/" className="nav-link">Home</NavLink></li>
          <li><NavLink to="/about" className="nav-link">About</NavLink></li>
          <li><NavLink to="/services" className="nav-link">Services</NavLink></li>
          <li><NavLink to="/expatriate-support" className="nav-link">Expat Support</NavLink></li>
          <li><NavLink to="/contact" className="nav-link">Contact</NavLink></li>
        </ul>
      </nav>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-inner">
          <button className="btn close-btn" onClick={closeMenu}>
            <i className="bi bi-x-lg fs-2"></i>
          </button>
          <ul className="nav flex-column text-center mb-4">
            <li><NavLink to="/" className="nav-link" onClick={closeMenu}><i className="bi bi-house me-2"></i>Home</NavLink></li>
            <li><NavLink to="/about" className="nav-link" onClick={closeMenu}><i className="bi bi-info-circle me-2"></i>About</NavLink></li>
            <li><NavLink to="/services" className="nav-link" onClick={closeMenu}><i className="bi bi-briefcase me-2"></i>Services</NavLink></li>
            <li><NavLink to="/expatriate-support" className="nav-link" onClick={closeMenu}><i className="bi bi-person-check me-2"></i>Expat Support</NavLink></li>
            <li><NavLink to="/contact" className="nav-link" onClick={closeMenu}><i className="bi bi-envelope me-2"></i>Contact</NavLink></li>
          </ul>
        </div>
      </div>
    </>
  );
}
